// Gapsmiths badge — cyan hexagon with a white lightbulb and plug contacts.
// Recreated as SVG from the brand logo so it scales crisply at any size.
export default function LogoMark({ className = "" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Gapsmiths"
    >
      <polygon
        points="256,36 446,146 446,366 256,476 66,366 66,146"
        fill="#16a9e0"
        stroke="#16a9e0"
        strokeWidth="36"
        strokeLinejoin="round"
      />
      <g fill="#ffffff">
        <rect x="198" y="98" width="30" height="26" rx="7" transform="rotate(-16 213 111)" />
        <rect x="284" y="98" width="30" height="26" rx="7" transform="rotate(16 299 111)" />
      </g>
      <g stroke="#ffffff" strokeWidth="7" strokeLinecap="round">
        <line x1="206" y1="96" x2="200" y2="82" transform="rotate(-16 213 111)" />
        <line x1="220" y1="96" x2="216" y2="80" transform="rotate(-16 213 111)" />
        <line x1="292" y1="96" x2="296" y2="80" transform="rotate(16 299 111)" />
        <line x1="306" y1="96" x2="312" y2="82" transform="rotate(16 299 111)" />
      </g>
      <path
        d="M208 300 C176 280 158 250 158 216 C158 168 202 132 256 132 C310 132 354 168 354 216 C354 250 336 280 304 300"
        fill="none"
        stroke="#ffffff"
        strokeWidth="12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M212 300 L216 312 M300 300 L296 312"
        stroke="#ffffff"
        strokeWidth="12"
        strokeLinecap="round"
      />
      <rect x="214" y="306" width="84" height="44" rx="9" fill="#ffffff" />
      <line x1="224" y1="320" x2="288" y2="320" stroke="#16a9e0" strokeWidth="6" strokeLinecap="round" />
      <line x1="224" y1="334" x2="288" y2="334" stroke="#16a9e0" strokeWidth="6" strokeLinecap="round" />
      <path
        d="M226 350 C236 372 276 372 286 350"
        fill="none"
        stroke="#ffffff"
        strokeWidth="11"
        strokeLinecap="round"
      />
      <path id="gs-arc" d="M150 268 Q256 214 362 268" fill="none" />
      <text fill="#ffffff" fontFamily="'Permanent Marker', cursive" fontSize="46">
        <textPath href="#gs-arc" startOffset="50%" textAnchor="middle">
          GAPSMITHS
        </textPath>
      </text>
    </svg>
  );
}
